
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';

const json = {
  1: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P15-E1',
    audio: '',
    video: '',
    component: D1,
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page15/E1/Key/answerKey.png',
    textAlign: 'center',
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page15/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page15/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page15/E1/3.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page15/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page15/E1/5.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page15/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page15/E1/7.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page15/E1/8.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page15/E1/9.jpg' },
      ],

    ],
  },
  2: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P15-E2',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page15/E2/Key/answerKey.png',
    component: MatchDots,
    titleQuestion: [{ num: '2', title: 'Match', color: "#5B5A5D" }],

    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [

          { boxMatchStyle: { position: 'absolute', top: '122px', left: '437px', width: 179, height: 131 } },
          { boxMatchStyle: { position: 'absolute', top: '122px', left: '742px', width: 183, height: 131 } },
          { boxMatchStyle: { position: 'absolute', top: '122px', left: '1042px', width: 183, height: 131 } },

          { boxMatchStyle: { position: 'absolute', top: '298px', left: '274px', width: 183, height: 131 } },
          { boxMatchStyle: { position: 'absolute', top: '298px', left: '880px', width: 183, height: 131 } },
        ],
        answers: ['0-3', '1-4', '2-4'],
        initialValue: [],
      },
      Layout: `
          <img src='img/FriendsPlus/Page15/E2/1.jpg' />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />

          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
      `,
    },
  },

  3: { // Exercise num
    unit: 'Unit 2',
    id: 'WB3-U2-P15-E3',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page15/E3/Key/answerKey.png',
    checkUppercase: true,
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page15/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page15/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page15/E3/3.jpg', input: true, answer: "Those are" },
        { url: 'img/FriendsPlus/Page15/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page15/E3/5.jpg', input: true, answer: "This is" },
        { url: 'img/FriendsPlus/Page15/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page15/E3/7.jpg', input: true, answer: "That is" },
        { url: 'img/FriendsPlus/Page15/E3/8.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page15/E3/9.jpg' },
      ],

    ],
  },

}

export default json;